module.exports = __webpack_public_path__ + "img/数据中心特色.4f1d6325.png";